import { apiClient } from '@/services/api';

export const accountService = {
  /**
   * DELETE /api/v1/account — Apple Guideline 5.1.1(v) in-app account deletion.
   * Server anonymizes PII and revokes every session, so the existing Bearer
   * token becomes useless immediately after this returns. Callers should
   * follow with authStore.clear() to drop local state and bounce to login.
   */
  async deleteAccount(): Promise<void> {
    await apiClient.del('/api/v1/account');
  },
};
